/*
 * Newsletter-Popup — Auslöser und Häufigkeitsgrenze.
 *
 * Der Dialog selbst ist Dawns `modal-dialog` aus global.js; von dort kommen
 * Fokus-Falle, ESC, Klick ausserhalb und Scroll-Sperre. Diese Datei entscheidet
 * ausschliesslich, WANN er erscheint.
 *
 * Auslöser ist Exit-Intent, nicht ein Zeitgeber: Auf dem Desktop die Maus
 * Richtung Adresszeile, auf Touch-Geräten schnelles Hochscrollen. Damit
 * erscheint das Popup erst, wenn der Besuch ohnehin endet — es verdeckt weder
 * den Erstbesuch noch den Footer.
 */
(() => {
  const SPEICHER = 'skullpot:newsletter-popup';

  const dialog = document.getElementById('NewsletterPopup');
  if (!dialog) return;

  const tage = Number(dialog.dataset.verzoegerungTage) || 30;

  /* `form.posted_successfully?` und `form.errors` gelten in Liquid für jedes
     Kundenformular der Seite — der Footer trägt ein zweites. Ohne diese Prüfung
     öffnete eine Footer-Anmeldung das Popup und zeigte den Rabattcode, obwohl
     der Besucher das Popup nie benutzt hat.

     Unterscheidbar sind die beiden nur über das Fragment: Shopify hängt die
     Formular-ID an das Ziel an, sie steht nach dem Absenden in der Adresszeile. */
  const ausDiesemFormular = window.location.hash === '#' + dialog.dataset.formularId;
  const erfolg = dialog.querySelector('.newsletter-popup__code') !== null;
  const fehler = dialog.querySelector('.newsletter-popup__message') !== null;

  if (erfolg || fehler) {
    /* Nach dem Absenden lädt Shopify die Seite neu. Stammt die Einsendung aus
       diesem Formular, muss der Dialog von selbst aufgehen — im Erfolgsfall mit
       dem Code, im Fehlerfall mit der Meldung. Ohne das bliebe ein Fehler
       unsichtbar. */
    if (ausDiesemFormular) {
      if (erfolg) merken();
      window.requestAnimationFrame(() => dialog.show(document.body));
      return;
    }

    /* Sonst stammt der Zustand von einem anderen Kundenformular der Seite,
       etwa dem im Footer — Liquid kann die beiden nicht auseinanderhalten. Der
       Dialog trägt dann einen Erfolgs- oder Fehlerzustand, der diesen Besucher
       nichts angeht; ohne diesen Ausstieg würde Exit-Intent ihm später den
       Rabattcode zeigen, obwohl er das Popup nie benutzt hat. Auf diesem einen
       Seitenaufruf erscheint das Popup deshalb gar nicht. */
    return;
  }

  if (kuerzlichGezeigt()) return;

  let ausgeloest = false;

  function zeigen() {
    if (ausgeloest) return;
    ausgeloest = true;
    abmelden();
    merken();
    dialog.show(document.body);
  }

  function kuerzlichGezeigt() {
    try {
      const wert = window.localStorage.getItem(SPEICHER);
      if (!wert) return false;
      const alter = Date.now() - Number(wert);
      return alter < tage * 24 * 60 * 60 * 1000;
    } catch (e) {
      /* Privater Modus oder gesperrter Speicher: dann lieber einmal zu viel
         zeigen als gar nicht. */
      return false;
    }
  }

  function merken() {
    try {
      window.localStorage.setItem(SPEICHER, String(Date.now()));
    } catch (e) {
      /* bewusst still — ohne Speicher greift nur die Sperre je Seitenaufruf */
    }
  }

  /* Desktop: Zeiger verlässt das Fenster nach oben. `relatedTarget` ist dabei
     null, wenn der Zeiger das Dokument wirklich verlässt und nicht nur ein
     Kindelement wechselt. */
  function aufMausAus(event) {
    if (event.clientY > 0) return;
    if (event.relatedTarget || event.toElement) return;
    zeigen();
  }

  /* Touch: schnelles Hochscrollen nach einer gewissen Tiefe. Ein reines
     Hochscrollen genügt nicht — sonst löst jedes Zurückblättern aus. */
  let letzteY = window.scrollY;
  let letzteZeit = Date.now();

  function aufScroll() {
    const y = window.scrollY;
    const jetzt = Date.now();
    const dy = letzteY - y;
    const dt = jetzt - letzteZeit;

    if (dt > 0 && dy > 0 && y < 400 && letzteY > 600) {
      const geschwindigkeit = dy / dt;
      if (geschwindigkeit > 1.5) zeigen();
    }

    letzteY = y;
    letzteZeit = jetzt;
  }

  function abmelden() {
    document.removeEventListener('mouseout', aufMausAus);
    window.removeEventListener('scroll', aufScroll);
  }

  const zeigerFein = window.matchMedia('(pointer: fine)').matches;
  if (zeigerFein) {
    document.addEventListener('mouseout', aufMausAus);
  } else {
    window.addEventListener('scroll', aufScroll, { passive: true });
  }
})();
